// Drift Auditor -- equity-curve comparison (Buy & Hold vs Calendar vs Corridor).

import React from 'react';
import {
    CartesianGrid,
    Legend,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts';

import type { TimeSeriesPoint } from '../types';

const fmtMoneyShort = (v: number): string => {
    if (Math.abs(v) >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}M`;
    if (Math.abs(v) >= 1_000) return `$${(v / 1_000).toFixed(0)}k`;
    return `$${v.toFixed(0)}`;
};

export const WealthChart: React.FC<{ data: TimeSeriesPoint[] }> = ({ data }) => (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-5">
        <h3 className="text-base font-bold text-slate-800">Growth of Capital</h3>
        <p className="text-xs text-slate-500 mt-0.5 mb-3">Cumulative wealth by rebalancing discipline.</p>
        <div className="h-72 w-full">
            <ResponsiveContainer width="100%" height="100%">
                <LineChart data={data} margin={{ top: 5, right: 8, left: 4, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
                    <XAxis
                        dataKey="date"
                        tick={{ fontSize: 11, fill: '#94a3b8' }}
                        minTickGap={48}
                        tickLine={false}
                    />
                    <YAxis
                        tickFormatter={fmtMoneyShort}
                        tick={{ fontSize: 11, fill: '#94a3b8' }}
                        width={56}
                        tickLine={false}
                        axisLine={false}
                        domain={['auto', 'auto']}
                    />
                    <Tooltip
                        formatter={(v: number) => `$${Math.round(v).toLocaleString('en-US')}`}
                        contentStyle={{ borderRadius: 12, border: '1px solid #e2e8f0', fontSize: 12 }}
                    />
                    <Legend wrapperStyle={{ fontSize: 12 }} />
                    <Line
                        type="monotone"
                        dataKey="drifted_wealth"
                        name="Unchecked Drift"
                        stroke="#f43f5e"
                        strokeWidth={2}
                        dot={false}
                    />
                    <Line
                        type="monotone"
                        dataKey="calendar_wealth"
                        name="Annual Calendar"
                        stroke="#0ea5e9"
                        strokeWidth={2}
                        dot={false}
                    />
                    <Line
                        type="monotone"
                        dataKey="corridor_wealth"
                        name="Relative Corridor"
                        stroke="#6366f1"
                        strokeWidth={2.5}
                        dot={false}
                    />
                    <Line
                        type="monotone"
                        dataKey="ai_pro_wealth"
                        name="Forge Ultra Regime (PRO)"
                        stroke="#10b981"
                        strokeWidth={2.5}
                        strokeDasharray="5 3"
                        dot={false}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    </div>
);
